import type { ReactNode } from 'react';

import Tooltip from '@/components/atoms/Tooltip';

import type { HealthAlertBadgeVariant } from '../../HealthDashboard/healthAlertDisplay';

import styles from './HealthAlarmMetricTooltip.module.scss';

export interface HealthAlarmMetricTooltipProps {
    label: string;
    description: string;
    variant?: HealthAlertBadgeVariant;
    children: ReactNode;
}

export default function HealthAlarmMetricTooltip(props: HealthAlarmMetricTooltipProps) {
    const { label, description, variant = 'inline', children } = props;
    const placement = variant === 'pill' ? 'bottom' : 'right';

    return (
        <div className={styles.tooltipWrapper}>
            <Tooltip
                placement={placement}
                maxWidth={280}
                layout="inline"
                content={
                    <div className={styles.content}>
                        <p className={styles.title}>{label}</p>
                        <p className={styles.description}>{description}</p>
                    </div>
                }>
                {children}
            </Tooltip>
        </div>
    );
}
